{
  "de": {
    "filteredList": {
      "actions": {
        "showFilter": "Filter anzeigen",
        "hideFilter": "Filter ausblenden"
      }
    }
  }
}
